// const STORAGE_KEY = "pendingAnswers";

// /**
//  * Save/Update one pending answer
//  */
// export const savePendingAnswer = (answer) => {

//     const pending = JSON.parse(
//         localStorage.getItem(STORAGE_KEY) || "{}"
//     );

//     pending[answer.question_id] = answer;

//     localStorage.setItem(
//         STORAGE_KEY,
//         JSON.stringify(pending)
//     );
// };

// /**
//  * Remove one answer after ACK
//  */
// export const removePendingAnswer = (questionId) => {

//     const pending = JSON.parse(
//         localStorage.getItem(STORAGE_KEY) || "{}"
//     );

//     delete pending[questionId];

//     localStorage.setItem(
//         STORAGE_KEY,
//         JSON.stringify(pending)
//     );
// };

// /**
//  * Read all pending answers
//  */
// // export const getPendingAnswers = () => {

// //     return JSON.parse(
// //         localStorage.getItem(STORAGE_KEY) || "{}"
// //     );
// // };
// export const getPendingAnswers = () => {

//     const pending = JSON.parse(
//         localStorage.getItem(STORAGE_KEY) || "{}"
//     );

//     Object.keys(pending).forEach(key => {

//         if (
//             key === "undefined" ||
//             key === "null" ||
//             pending[key]?.question_id == null
//         ) {
//             delete pending[key];
//         }

//     });

//     return pending;
// };
// /**
//  * Clear everything
//  */
// export const clearPendingAnswers = () => {

//     localStorage.removeItem(STORAGE_KEY);

// };

// /**
//  * Count pending answers
//  */
// export const getPendingCount = () => {

//     return Object.keys(getPendingAnswers()).length;

// };


const getStorageKey = (examEmployeeId) => {
    return `pendingAnswers_${examEmployeeId}`;
};
 
 
/**
 * Save/Update one pending answer
 */
export const savePendingAnswer = (examEmployeeId, answer) => {
 
    if (!examEmployeeId) {
        console.error(
            "[PENDING] examEmployeeId is missing while saving answer"
        );
        return;
    }
 
    if (answer?.question_id == null) {
        console.error(
            "[PENDING] question_id is missing while saving answer",
            answer
        );
        return;
    }
 
    const STORAGE_KEY = getStorageKey(examEmployeeId);
 
    const pending = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || "{}"
    );
 
    // One latest answer per question
    pending[String(answer.question_id)] = answer;
 
    localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(pending)
    );
 
    console.log(
        `[PENDING] Saved locally | ExamEmployee=${examEmployeeId} | Question=${answer.question_id}`
    );
};
 
 
/**
 * Remove one answer after Mongo/WebSocket ACK
 */
export const removePendingAnswer = (
    examEmployeeId,
    questionId
) => {
 
    if (!examEmployeeId || questionId == null) {
        return;
    }
 
    const STORAGE_KEY = getStorageKey(examEmployeeId);
 
    const pending = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || "{}"
    );
 
    delete pending[String(questionId)];
 
    localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(pending)
    );
 
    console.log(
        `[PENDING] Removed after ACK | ExamEmployee=${examEmployeeId} | Question=${questionId}`
    );
};
 
 
/**
 * Read all pending answers for the current exam only
 */
export const getPendingAnswers = (examEmployeeId) => {
 
    if (!examEmployeeId) {
        console.error(
            "[PENDING] examEmployeeId is missing while reading pending answers"
        );
        return {};
    }
 
    const STORAGE_KEY = getStorageKey(examEmployeeId);
 
    let pending = {};
 
    try {
 
        pending = JSON.parse(
            localStorage.getItem(STORAGE_KEY) || "{}"
        );
 
    } catch (error) {
 
        console.error(
            "[PENDING] Invalid localStorage data. Clearing:",
            error
        );
 
        localStorage.removeItem(STORAGE_KEY);
 
        return {};
    }
 
 
    let isChanged = false;
 
    Object.keys(pending).forEach((key) => {
 
        if (
            key === "undefined" ||
            key === "null" ||
            pending[key]?.question_id == null
        ) {
 
            console.warn(
                "[PENDING] Removing invalid pending answer:",
                key
            );
 
            delete pending[key];
            isChanged = true;
        }
    });
 
 
    // Save cleaned data back to localStorage
    if (isChanged) {
 
        localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify(pending)
        );
    }
 
    return pending;
};
 
 
/**
 * Clear pending answers for this exam only
 */
export const clearPendingAnswers = (examEmployeeId) => {
 
    if (!examEmployeeId) {
        return;
    }
 
    const STORAGE_KEY = getStorageKey(examEmployeeId);
 
    localStorage.removeItem(STORAGE_KEY);
 
    console.log(
        `[PENDING] Cleared | ExamEmployee=${examEmployeeId}`
    );
};
 
 
/**
 * Count pending answers for this exam only
 */
export const getPendingCount = (examEmployeeId) => {
 
    return Object.keys(
        getPendingAnswers(examEmployeeId)
    ).length;
};
 